import React, { useEffect, useState } from "react";
import Footer from "../shared/Footer";
import Navbar from "../shared/Navbar";
import Sidebar from "../shared/Sidebar";
import config from "../../config";
import { useNavigate } from "react-router-dom";
import {
  MdOutlineKeyboardDoubleArrowRight,
  MdOutlineKeyboardArrowRight,
  MdOutlineKeyboardDoubleArrowLeft,
  MdOutlineKeyboardArrowLeft,
} from "react-icons/md";

function Consolidatedchecklist() {
  const [students, setStudents] = useState([]);
  const [loading, setLoading] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const [perPage, setPerPage] = useState(100);
  const navigate = useNavigate();
  const [searchQuery, setSearchQuery] = useState("");

  const [showPdfViewer, setShowPdfViewer] = useState(false);
  const [pdfUrl, setPdfUrl] = useState("");

  const handleDownloadClick = () => {
    setPdfUrl("/list-of-examinees-cl-9");
    setShowPdfViewer(true);
  };

  const closePdfViewer = () => {
    setShowPdfViewer(false);
    setPdfUrl("");
  };

  useEffect(() => {
    const fetchStudentData = async () => {
      const token = sessionStorage.getItem("tokenclassix");
      // const schoolCode = sessionStorage.getItem("schoolCode");

      try {
        const response = await fetch(
          `${config.API_BASE_URL}/ConsolidateListOfStudent_CL9`,
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
          }
        );

        const result = await response.json();
        if (response.ok) {
          setLoading(false);
          setStudents(result?.data.consolidateStudent_list || []);
        } else {
          setLoading(false);
          console.error("Failed to fetch students", result);
        }
      } catch (error) {
        setLoading(false);
        console.error("Error fetching student data:", error);
      }
    };

    fetchStudentData();
  }, []);

  // Filter logic
  const filteredStudents = students.filter((student) => {
    const query = searchQuery.toLowerCase();
    return (
      student.candidatE_NAME?.toLowerCase().includes(query) ||
      student.fatheR_NAME?.toLowerCase().includes(query) ||
      student.motheR_NAME?.toLowerCase().includes(query) ||
      student.dob?.toLowerCase().includes(query) ||
      student.aadhaR_CARD?.includes(query) ||
      student.actuaL_CATEGORY?.toLowerCase().includes(query) ||
      student.checklisT_STATUS?.toLowerCase().includes(query) ||
      student.deO_STATUS?.toLowerCase().includes(query) ||
      student.divyanG_NAME?.toLowerCase().includes(query) ||
      student.castE_NAME?.toLowerCase().includes(query) ||
      student.area?.toLowerCase().includes(query) ||
      student.state?.toLowerCase().includes(query) ||
      student.district?.toLowerCase().includes(query) ||
      student.blocK_NAME?.toLowerCase().includes(query) ||
      student.address?.toLowerCase().includes(query) ||
      student.pincode?.toLowerCase().includes(query) ||
      student.contacT_NO?.toLowerCase().includes(query) ||
      student.emaiL_ID?.toLowerCase().includes(query) ||
      // student.peN_NO?.toLowerCase().includes(query) ||
      student.prinT_CATEGORY?.toLowerCase().includes(query) ||
      student.mediuM_NAME?.toLowerCase().includes(query) ||
      student.subjecT_1?.toLowerCase().includes(query) ||
      student.subjecT_2?.toLowerCase().includes(query) ||
      student.subjecT_3?.toLowerCase().includes(query) ||
      student.subjecT_4?.toLowerCase().includes(query) ||
      student.subjecT_5?.toLowerCase().includes(query) ||
      student.subjecT_6?.toLowerCase().includes(query)
    );
  });

  // Pagination logic
  const totalPages = Math.ceil(filteredStudents.length / perPage);
  const indexOfLastItem = currentPage * perPage;
  const indexOfFirstItem = indexOfLastItem - perPage;
  const currentItems = filteredStudents.slice(
    indexOfFirstItem,
    indexOfLastItem
  );
  const handlePerPageChange = (e) => {
    setPerPage(Number(e.target.value));
    setCurrentPage(1);
  };

  return (
    <>
      <div className="container-scroller">
        <Navbar />
        {loading && (
          <div className="custom-loader-container">
            <div className="custom-loader"></div>
          </div>
        )}
        <div className="container-fluid page-body-wrapper">
          <Sidebar />
          <div className="main-panel">
            <div className="content-wrapper">
              <div className="row">
                <div className="col-md-12 mb-1">
                  <section className="content-header">
                    <h1>
                      <i className="fa fa-user"></i>&nbsp; List of Registered
                      Students
                    </h1>
                    <ol className="breadcrumb">
                      <li>
                        <a
                          href="#"
                          onClick={() => navigate("/class-ix-dashboard")}
                        >
                          <i className="fa fa-home" /> Home
                        </a>
                      </li>
                      <li className="active">List of Registered Students</li>
                    </ol>
                  </section>
                </div>
              </div>

              <div className="row">
                <div className="col-md-12 mb-4 stretch-card">
                  <div className="card">
                    <div className="card-body">
                      <div className="row mb-2">
                        {students.length > 0 && (
                          <div style={{ textAlign: "right" }}>
                            {/* <a
                              className="btn btn-sm btn-success"
                              href="#"
                              onClick={() =>
                                window.open("/list-of-examinees-cl-9", "_blank")
                              }
                            >
                              <i className="fa fa-download"></i>&nbsp;Download
                              List of Registered Students
                            </a> */}
                            <a
                              className="btn btn-sm btn-success"
                              href="#"
                              onClick={(e) => {
                                e.preventDefault();
                                handleDownloadClick();
                              }}
                            >
                              <i className="fa fa-download"></i>&nbsp;Download
                              List of Registered Students
                            </a>
                          </div>
                        )}
                      </div>
                      <div className="row align-items-center justify-content-between mb-3">
                        <div className="d-flex justify-content-between align-items-center mb-2">
                          <div className="d-flex align-items-center">
                            <label htmlFor="rowsPerPage" className="me-2 mb-0">
                              Rows:
                            </label>
                            <div style={{ width: "150px" }}>
                              <select
                                id="rowsPerPage"
                                className="form-select form-select-sm"
                                value={perPage}
                                onChange={handlePerPageChange}
                                style={{
                                  width: "80px", // or adjust as needed (80–120px)
                                  paddingRight: "2rem", // ensures space for the dropdown arrow
                                }}
                              >
                                {[10, 20, 50, 100, 500].map((num) => (
                                  <option key={num} value={num}>
                                    {num}
                                  </option>
                                ))}
                              </select>
                            </div>
                          </div>

                          {/* Search on the right */}
                          <div style={{ width: "200px" }}>
                            <input
                              type="text"
                              className="form-control form-control-sm"
                              placeholder="Search..."
                              value={searchQuery}
                              onChange={(e) => setSearchQuery(e.target.value)}
                            />
                          </div>
                        </div>
                      </div>

                      <div
                        className="col-md-12"
                        style={{ overflowX: "auto", width: "100%" }}
                      >
                        <table className="table table-bordered table-condensed table-striped">
                          <thead>
                            <tr>
                              <th colSpan="11">Student Details</th>
                              <th colSpan="8">Communication Details</th>
                              <th colSpan="8">Educational Details</th>
                            </tr>
                            <tr className="table-primary">
                              <th>Sl No.</th>
                              <th>Name of Candidate</th>
                              <th>Gender</th>
                              <th>Date of Birth</th>
                              <th>Father's Name</th>
                              <th>Mother's Name</th>
                              <th>Religion</th>
                              <th>Nationality</th>
                              <th>Aadhaar Number</th>
                              <th>Divyang</th>
                              <th>Caste</th>
                              <th>Area</th>
                              <th>State</th>
                              <th>District</th>
                              <th>Block</th>
                              <th>Address</th>
                              <th>Pin</th>
                              <th>Student Contact Number</th>
                              <th>Email ID</th>
                              <th>Category</th>
                              <th>Medium of Exam</th>
                              <th>Language I</th>
                              <th>Language II</th>
                              <th>Compulsory I</th>
                              <th>Compulsory II</th>
                              <th>Compulsory III</th>
                              <th>Additional</th>
                            </tr>
                          </thead>
                          <tbody>
                            {currentItems.length > 0 ? (
                              currentItems.map((student, index) => (
                                <tr key={index}>
                                  <td>{indexOfFirstItem + index + 1}</td>
                                  <td>{student.candidatE_NAME}</td>
                                  <td>{student.gender}</td>
                                  <td>{student.dob}</td>
                                  <td>{student.fatheR_NAME}</td>
                                  <td>{student.motheR_NAME}</td>
                                  <td>{student.religioN_NAME}</td>
                                  <td>{student.nationality}</td>
                                  <td>
                                    {student.aadhaR_CARD
                                      ? "********" +
                                        student.aadhaR_CARD.slice(-4)
                                      : ""}
                                  </td>
                                  <td>{student.divyanG_NAME}</td>
                                  <td>{student.castE_NAME}</td>
                                  <td>{student.area}</td>
                                  <td>{student.state}</td>
                                  <td>{student.district}</td>
                                  <td>{student.blocK_NAME}</td>
                                  <td>{student.address}</td>
                                  <td>{student.pincode}</td>
                                  <td>{student.contacT_NO}</td>
                                  <td>{student.emaiL_ID}</td>
                                  <td>{student.prinT_CATEGORY}</td>
                                  <td>{student.mediuM_NAME}</td>
                                  <td>{student.subjecT_1}</td>
                                  <td>{student.subjecT_2}</td>
                                  <td>{student.subjecT_3}</td>
                                  <td>{student.subjecT_4}</td>
                                  <td>{student.subjecT_5}</td>
                                  <td>{student.subjecT_6}</td>
                                </tr>
                              ))
                            ) : (
                              <tr>
                                <td colSpan={27}>No data found</td>
                              </tr>
                            )}
                          </tbody>
                        </table>
                      </div>

                      <div className="d-flex justify-content-between align-items-center mt-3">
                        <div>
                          Showing {indexOfFirstItem + 1} to{" "}
                          {Math.min(indexOfLastItem, filteredStudents.length)}{" "}
                          of {filteredStudents.length} entries
                        </div>
                        <div className="d-flex align-items-center gap-2">
                          <MdOutlineKeyboardDoubleArrowLeft
                            onClick={() => setCurrentPage(1)}
                            style={{
                              cursor:
                                currentPage > 1 ? "pointer" : "not-allowed",
                              opacity: currentPage > 1 ? 1 : 0.5,
                            }}
                          />
                          <MdOutlineKeyboardArrowLeft
                            onClick={() =>
                              currentPage > 1 &&
                              setCurrentPage((prev) => prev - 1)
                            }
                            style={{
                              cursor:
                                currentPage > 1 ? "pointer" : "not-allowed",
                              opacity: currentPage > 1 ? 1 : 0.5,
                            }}
                          />
                          <span>
                            Page {currentPage} of {totalPages}
                          </span>
                          <MdOutlineKeyboardArrowRight
                            onClick={() =>
                              currentPage < totalPages &&
                              setCurrentPage((prev) => prev + 1)
                            }
                            style={{
                              cursor:
                                currentPage < totalPages
                                  ? "pointer"
                                  : "not-allowed",
                              opacity: currentPage < totalPages ? 1 : 0.5,
                            }}
                          />
                          <MdOutlineKeyboardDoubleArrowRight
                            onClick={() => setCurrentPage(totalPages)}
                            style={{
                              cursor:
                                currentPage < totalPages
                                  ? "pointer"
                                  : "not-allowed",
                              opacity: currentPage < totalPages ? 1 : 0.5,
                            }}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {showPdfViewer && (
              <div
                style={{
                  position: "fixed",
                  top: 0,
                  left: 0,
                  width: "100%",
                  height: "100%",
                  backgroundColor: "rgba(0, 0, 0, 0.8)",
                  zIndex: 9999,
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <div
                  style={{
                    width: "90%",
                    height: "90%",
                    backgroundColor: "white",
                    borderRadius: "8px",
                    position: "relative",
                    display: "flex",
                    flexDirection: "column",
                  }}
                >
                  {/* HEADER */}
                  <div
                    style={{
                      padding: "10px",
                      borderBottom: "1px solid #ddd",
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                    }}
                  >
                    <h5 style={{ margin: 0 }}>
                      List of Registered Students PDF
                    </h5>
                    <button
                      onClick={closePdfViewer}
                      style={{
                        background: "#dc3545",
                        color: "white",
                        border: "none",
                        borderRadius: "4px",
                        padding: "8px 16px",
                        cursor: "pointer",
                      }}
                    >
                      Close
                    </button>
                  </div>

                  {/* IFRAME VIEWER */}
                  <iframe
                    src={pdfUrl}
                    style={{
                      width: "100%",
                      height: "calc(100% - 60px)",
                      border: "none",
                      borderRadius: "0 0 8px 8px",
                    }}
                    title="PDF Viewer"
                  />
                </div>
              </div>
            )}
            <Footer />
          </div>
        </div>
      </div>
    </>
  );
}

export default Consolidatedchecklist;
